<template>
<div class="container mt-5" style="height:300px">
    <!-- Modal loader start -->
     <div v-if="dialogLoading" class="loading-state">
        <div class="loading"></div>
        <span class="ml-3 loading-text">Votre demande est en cours de traitement</span>
    </div>


    <!-- <div class="text-xs-center">
        <v-dialog v-model="dialogLoading" hide-overlay persistent width="300">
            <v-card color="orange" dark>
                <v-card-text>
                    Votre demande est en cours de traitement
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div> -->
</div>
</template>

<script>
import Api from "../services/Api";
import axios from 'axios'
import store from '../store/store'
import Delivery from '../services/Delivery'
import PushInDataLayer from '../services/TagManager';

export default {
    data() {
        return {
            Mano: null,
            dialogLoading: false,
            Contrat_provisoire: null,
            TheBranche: null,
            brancheName: null,
            ThePartner: null,
            numDevis: null,
            proprio: null,
            ToastTabSucess: { // Customized options for success toast
                theme: "toasted-primary",
                position: "top-center",
                duration: 5000,
                fitToScreen: true,
                type: "success",
                className: "custom-success-class"
            },
            ToastTabError: { // Customized options for error toast
                theme: "toasted-primary",
                position: "top-center",
                duration: 5000,
                fitToScreen: true,
                type: "error"
            },
        }
    },
    created() {
        this.fetchEventsList();
        this.timer = setInterval(this.fetchEventsList, 1000)
    },
    methods: {

        BlockPaymentLink() {
            let id = localStorage.getItem('PaymentlinkId');
            if (typeof id !== 'undefined' && typeof id == 'string') {
                Api().post('paymentLink/block/link', {
                        id: id
                    })
                    .then(response => {
                        localStorage.setItem('Blocked Link', JSON.stringify(response.data))
                    })
            }

        },

        sendmailAdmin: function () {
            let amount = localStorage.getItem('amount');
            let numdevis = localStorage.getItem('numDevis');
            const body = {
                sender_email: "Assuraf Logs inTouch",
                sujet: "Paiement de contrat par intouch ",
                message: "Paiement de " + amount + " FCFA à assuraf.com a bien été validé par \n " + "Nom et Prenom : " + this.$store.state.user.nom + " " + this.$store.state.user.prenom + "\n N° devis : " + numdevis + "\n" + "Date :" + Date()
            };

            Api().post('messaegeadmin/sendMail', body)
                .then(res => {
                    console.log(res)
                })
                .catch(err => {
                    console.error(err)
                })
        },

        //Recuperation URL pour l Envoie sms au client
        sendsmsclient: function (contrat, branche) {
            let host = '';
            let numcli = this.$store.state.user.telephone_port;
            let adresstosend = numcli.substring(numcli.length - 9);
            if (branche == 'Santé') {
                host = 'https://api.assuraf.com/api/uploads/Contrat_provisoir_Sante_' + contrat._id + ".pdf"
            } else {
                host = 'https://api.assuraf.com/api/uploads/Contrat_provisoir_' + branche + '_' + contrat._id + ".pdf"
            }
            const orangeToken = process.env.VUE_APP_ORANGE_SMS_TOKEN || '';
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': orangeToken,
            };
            if (orangeToken) {
                axios.defaults.headers.common['Authorization'] = "Bearer " + orangeToken;
            }
            const textclient = {
                outboundSMSMessageRequest: {
                    address: "tel:+221" + adresstosend,
                    senderAddress: "tel:+221772981201",
                    outboundSMSTextMessage: {
                        message: "Assuraf vous informe que votre demande a été bien finalisée et votre attestation est disponible ici " + " " + host
                    },
                }
            };

            axios.post('https://api.orange.com/smsmessaging/v1/outbound/tel:+221772981201/requests', textclient, headers)
                .then(res => {
                    console.log(res)
                })
                .catch(err => {
                    console.error(err)
                })
        },

        /*====================================*/
        /*Push purchase event in the dataLayer*/
        /*====================================*/ 
        purchasePushin()
        {
            if(this.$store.state.devispayement !== null && typeof this.$store.state.devispayement !== 'undefined')
            {
                let purchasePushin = JSON.parse(localStorage.getItem('purchasePushin'))
                purchasePushin.ecommerce.transaction_id = (this.$store.state.devispayement.devis.numeroDevis).replace(/[/]/g, '_');
                PushInDataLayer(purchasePushin)
            }

            if(this.$store.state.devis !== null && typeof this.$store.state.devis !== 'undefined')
            {
                let purchasePushin = JSON.parse(localStorage.getItem('purchasePushin'))
                purchasePushin.ecommerce.transaction_id = (this.$store.state.devis.result.devis.numeroDevis).replace(/[/]/g, '_');
                PushInDataLayer(purchasePushin)
            }
        },

        payement_end: function (params) 
        {    
            this.purchasePushin()

            const Contrat = {
                numero_police: params.numeroDevis,
                userid: params.userid,
                proprietaire: this.proprio,
                devisid: params._id,
                brancheid: this.TheBranche,
                partenaireid: this.ThePartner,
                courtierid: params.courtierid, 
                dateEffet: params.dateEffet,
                dateEcheance: params.dateEcheance,
                dateSouscription: params.dateSouscription,
                isExpress: false,
                taxe: params.taxe,
                prime_nette: params.prime_nette,
                prime_ttc: params.prime_ttc,
                bonus: params.bonus,
                accessoires: params.accessoires,
            };

            if (this.brancheName == 'Automobile') {
                let detailauto = {
                    vehicules: params.vehicules,
                    addrelivraison: localStorage.getItem('adressliv')
                };
                Contrat.details = detailauto
            }

            if (this.brancheName == 'Santé') {
                Contrat.details = this.$store.state.listeBeneficiaire
            }

            if (this.brancheName == 'Voyage') {
                Contrat.details = this.$store.state.listeBeneficiaire
                Contrat.mode_remboursement_voyage = params.mode_remboursement_voyage

            }

            if (this.brancheName == 'Habitation') {
                const habitat = {
                    typeBien: params.typeBien,
                    nombrepiece: params.nombrepiece,
                    nombreetage: params.nombreetage,
                    naturecouverture: params.naturecouverture,
                    adresselogement: params.adresselogement,
                    environnement_immediat: params.environnement_immediat,
                    valeurcontenu: params.valeurcontenu,
                    valeurbatiment: params.valeurbatiment,
                    qualiteassure: params.qualiteassure,
                };
                Contrat.details = habitat
            }

            Api().post('contrat/add', Contrat)
                .then(response => {
                    if (response.data.message == 'Contrat cree mais non envoye par email') {
                        this.sendmailAdmin();
                        this.BlockPaymentLink();
                        this.sendsmsclient(response.data.contrat, response.data.Thebranche);
                        this.contratToStore = response.data.contrat;
                        this.contratToStore.assureur = response.data.assureur;
                        this.contratToStore.branche = response.data.Thebranche;
                        this.$store.dispatch('setNewcontrat', this.contratToStore);
                        this.$store.dispatch('setDevisPayement', null);
                        this.testredirect()

                    } else if (response.data.message == 'Contrat cree et envoye par email') {
                        this.sendmailAdmin();
                        this.BlockPaymentLink();
                        this.sendsmsclient(response.data.contrat, response.data.Thebranche);
                        this.contratToStore = response.data.contrat;
                        this.contratToStore.assureur = response.data.assureur;
                        this.contratToStore.branche = response.data.Thebranche;
                        this.$store.dispatch('setNewcontrat', this.contratToStore);
                        this.$store.dispatch('setDevisPayement', null);
                        this.testredirect()
                    }

                })
                .catch(e => {})
        },

        testredirect: function () {
            this.$router.push('/contrat/ok')
        },

        getCallbackIntouch: function () {
            const params = new URLSearchParams(window.location.search);
            const CallBack = {
                num_transaction: params.get('num_transaction_from_gu'),
                num_command: params.get('num_command'),
                status: params.get('errorCode'),
                montant: params.get('amount'),
                numeroDevis: this.numDevis
            };

            Api().post('paymentstory/save_intouch_logs', CallBack)
                .then(response => {
                    (response)
                })
                .catch(err => {
                    (err)
                })
        },

        CheckintouchRes: function () {
            if (this.$store.state.devispayement !== null && typeof this.$store.state.devispayement !== 'undefined') 
            {

               if(localStorage.getItem('Recurrentpayment').toString() == 'true')
                {
                    const item = JSON.parse(localStorage.getItem('ReccurentPayItem'))
                    const data = {
                        userid : store.state.user._id,
                        numero: item.numero_police,
                        partenaireid : item.partenaireid._id,
                        brancheid : item.brancheid._id,
                        contratid : item._id,
                    }
                    Api().post('recurrentpay/create', data)
                    .then((result) => {
                        localStorage.removeItem('Recurrentpayment')
                        localStorage.removeItem('ReccurentPayItem')
                        this.dialogLoading = false
                        this.$toasted.show("Votre paiement a été pris en compte ! ", this.ToastTabSucess);
                       setTimeout((() => this.$router.push('/dashboard') ), 5000)
                    }).catch((err) => {
                        localStorage.removeItem('Recurrentpayment')
                        localStorage.removeItem('ReccurentPayItem')
                        this.dialogLoading = false
                        this.$toasted.show("Erreur lors du paiement !", this.ToastTabSucess);
                         setTimeout((() => this.$router.push('/dashboard') ), 5000)
                    });

                }else
                {
                
                    this.TheBranche = this.$store.state.devispayement.devis.brancheid._id;
                    this.ThePartner = this.$store.state.devispayement.devis.partenaireid._id;
                    this.brancheName = this.$store.state.devispayement.devis.brancheid.branche;
                    this.numDevis = this.$store.state.devispayement.devis.numeroDevis;
                    let numcommande = (this.$store.state.devispayement.devis.numeroDevis).replace(/[/]/g, '_');
                    this.proprio = this.$store.state.devispayement.devis.proprietaire;

                    if (localStorage.getItem('adressliv') !== ''){
                        Delivery(this.$store.state.devispayement.devis)
                    }       
                    try {
                        this.sendmailAdmin();
                        this.payement_end(this.$store.state.devispayement.devis);
                    } catch (error) {
                        this.$router.push('/payement/failed')
                    }
                }

            }
           
            if (this.$store.state.devis !== null && typeof this.$store.state.devis !== 'undefined') {
                this.TheBranche = this.$store.state.devis.result.branche[0]._id;
                this.ThePartner = this.$store.state.devis.result.partenaire._id;
                this.brancheName = this.$store.state.devis.result.branche[0].branche;
                this.numDevis = this.$store.state.devis.result.devis.numeroDevis;
                const params = new URLSearchParams(window.location.search);
                let errorCode = params.get('errorCode');
                if (errorCode == 200 || errorCode == 202) {
                    this.payement_end(this.$store.state.devis.result.devis);
                } else {
                    this.$router.push('/payement/failed')
                }
            }

        },
        fetchEventsList: function () {

            this.Mano = this.Mano - 1;
            if (this.Mano == 0) {
                clearInterval(this.timer);
                this.CheckintouchRes()
            }
        },

    },

    mounted() {
        window.scrollTo(0, 0);
        this.Mano = 3;
        this.dialogLoading = true;

    }

};
</script>

<style scoped>
.row-container {
    background: white;
    padding: auto;
    margin: auto;
}

span {
    font-weight: bold;
}

.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid #ddd;
  border-top-color: #ffa409;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
.loading-text{
    color: rgb(255, 255, 255);
    font-weight: bold;
}
</style>
